import { computed } from 'vue';
import i18n from '@/locales';

export function useMainBusinessMap() {
	const moduleList = computed(() => [
		{
			classifCd: 2,
			name: '按产品'
		},
		{
			classifCd: 1,
			name: '按行业'
		},
		{
			classifCd: 3,
			name: '按地区'
		}
	]);
	const scaleOptions = computed(() => {
		return [
			{ value: 1, label: i18n.t('enterprise.by-data'), text: i18n.t('enterprise.by-data') },
			{ value: 2, label: i18n.t('enterprise.by-scale'), text: i18n.t('enterprise.by-scale') }
		];
	});

	const dateOptions = computed(() => [
		{ value: 3, label: i18n.t('enterprise.lastThreeYear'), text: i18n.t('enterprise.lastThreeYear') },
		{ value: 5, label: i18n.t('enterprise.lastFiveYear'), text: i18n.t('enterprise.lastFiveYear') },
		{ value: 0, label: i18n.t('enterprise.all'), text: i18n.t('enterprise.all') }
	]);
	const comparisonPeriod = computed(() => [
		{
			value: 'S1',
			label: i18n.t('enterprise.interim'),
			text: i18n.t('enterprise.interim')
		},
		{
			value: 'A',
			label: i18n.t('enterprise.annual'),
			text: i18n.t('enterprise.annual')
		}
	]);
	return {
		moduleList,
		scaleOptions,
		dateOptions,
		comparisonPeriod
	};
}